import { Component } from 'react';
import { getAuthCredentials } from 'common/util/auth-storage';

import { SigningIframe } from 'part11/components/SigningIframe/SigningIframe';
import styles from './SignForm.scss';
import FileLink from 'common/components/FileLink/FileLink';

class SdfaSignForm extends Component {

    getSigningUrl() {
        const accessToken = getAuthCredentials().accessToken;
        return `${this.props.originUrl}/sign?access_token=${accessToken}&action_text=Sign Document and Complete Task`;
    }

    render() {
        const { onSignDocumentSubmit, document, signingStatement, viewDocument } = this.props;
        const signingUrl = this.getSigningUrl();

        return (
            <div className={styles.container} data-cy="SdfaSignForm">
                <div className={styles.form}>
                    <h2 className={styles.title}  data-cy="SdfaSignForm-title">
                        <FileLink
                            document={document}
                            onClick={viewDocument}/>
                    </h2>
                    <h3 className={styles.label}>
                        Statement of Testament
                    </h3>
                    <p className={styles.statementOfTestament} data-cy="SdfaSignForm-p">
                        { signingStatement }
                    </p>
                </div>

                <SigningIframe
                    url={signingUrl}
                    signDocument={onSignDocumentSubmit}
                    data-cy="SdfaSignForm-SigningIframe"/>
            </div>
        );
    }
}

export default SdfaSignForm;
